import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icons from '../icons';
import '../../styles/index.css';

export default function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh' }}>
            {/* Header */}
            <div style={{
                height: '50px', position: 'sticky', top: 0, left: '0px', right: '0px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
                alignItems: 'center', zIndex: 1000, backgroundColor: '#FFFFFF', borderBottom: '1px solid #E0E0E0'
            }}>
                <Link to="/" style={{ paddingLeft: '15px', color: 'green', textDecoration: 'none' }}>
                    <Icons icon="logo" size="160" color="#429a37" />
                </Link>
                <Link to="/" style={{ paddingRight: '20px', textDecoration: 'none', color: '#429a37', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: 500 }}>
                    ← Back to Home
                </Link>
            </div>

            {/* Content */}
            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
                <h1 style={{ fontSize: '36px', fontFamily: "'Roboto', sans-serif", fontWeight: 600, marginBottom: '10px', color: '#000000' }}>
                    Privacy Policy
                </h1>
                <p style={{ fontSize: '14px', fontFamily: "'Roboto', sans-serif", color: '#666666', marginBottom: '40px' }}>
                    Last Updated: December 31, 2024
                </p>

                <div style={{ fontFamily: "'Roboto', sans-serif", lineHeight: '1.8', color: '#333333' }}>
                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>1. Introduction</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Powerbox Energy Systems LLC ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, 
                            disclose, and safeguard your information when you visit our website or purchase our products.
                        </p>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Please read this Privacy Policy carefully. By using our website or services, you consent to the practices described in this policy.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>2. Information We Collect</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We may collect the following types of information:
                        </p>
                        
                        <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '20px', marginBottom: '10px', color: '#000000' }}>2.1 Personal Information</h3>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            When you make a purchase or contact us, we may collect:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>Name</li>
                            <li>Email address</li>
                            <li>Phone number</li>
                            <li>Delivery address</li>
                            <li>Payment information (processed securely through third-party payment processors)</li>
                        </ul>

                        <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '20px', marginBottom: '10px', color: '#000000' }}>2.2 Usage Information</h3>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We may automatically collect information about how you access and use our website, including:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>Browser type and version</li>
                            <li>Device information</li>
                            <li>IP address</li>
                            <li>Pages visited and time spent on pages</li>
                            <li>Referring website addresses</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>3. How We Use Your Information</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We use the information we collect to:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>Process and fulfill your orders</li>
                            <li>Communicate with you about your orders and account</li>
                            <li>Provide customer support</li>
                            <li>Send you marketing communications (with your consent)</li>
                            <li>Improve our website, products, and services</li>
                            <li>Prevent fraud and enhance security</li>
                            <li>Comply with legal obligations</li>
                            <li>Analyze website usage and trends</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>4. How We Share Your Information</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We do not sell or rent your personal information to third parties. We may share your information with:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li><strong>Service Providers:</strong> Third-party companies that help us operate our business (e.g., payment processors, delivery services, IT services)</li>
                            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
                            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
                        </ul>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            All third-party service providers are required to maintain the confidentiality and security of your information.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>5. Cookies and Tracking Technologies</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We use cookies and similar tracking technologies to enhance your experience on our website. Cookies are small files stored on your device that 
                            help us remember your preferences and understand how you use our site.
                        </p>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We use the following types of cookies:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
                            <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website (Google Analytics)</li>
                            <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
                        </ul>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            You can control cookies through your browser settings, but disabling cookies may affect website functionality.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>6. Data Security</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, 
                            disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee 
                            absolute security.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>7. Data Retention</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention 
                            period is required or permitted by law. When your information is no longer needed, we will securely delete or anonymize it.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>8. Your Rights</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            You have the following rights regarding your personal information:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
                            <li><strong>Correction:</strong> Request that we correct any inaccurate information</li>
                            <li><strong>Deletion:</strong> Request that we delete your personal information (subject to legal obligations)</li>
                            <li><strong>Opt-out:</strong> Unsubscribe from marketing communications at any time</li>
                            <li><strong>Data Portability:</strong> Request a copy of your data in a structured format</li>
                        </ul>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            To exercise these rights, please contact us at Support@powerbox.com.ng.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>9. Third-Party Links</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage 
                            you to review the privacy policies of any third-party sites you visit.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>10. Children's Privacy</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Our website and services are not directed to children under the age of 18. We do not knowingly collect personal information from children. 
                            If you believe we have collected information from a child, please contact us immediately.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>11. Changes to This Privacy Policy</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage 
                            you to review this policy periodically.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>12. Contact Us</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            If you have any questions or concerns about this Privacy Policy or our data practices, please contact us:
                        </p>
                        <div style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <p><strong>Powerbox Energy Systems LLC</strong></p>
                            <p>Ad1, Makarfi Street</p>
                            <p>Constitution, Kaduna</p>
                            <p>Nigeria</p>
                            <p>Email: Support@powerbox.com.ng</p>
                            <p>Phone: 09070811425</p>
                        </div>
                    </section>
                </div>
            </div>

            {/* Footer */}
            <div style={{ backgroundColor: '#F5F5F5', padding: '20px', textAlign: 'center', marginTop: '40px', borderTop: '1px solid #E0E0E0' }}>
                <p style={{ fontSize: '14px', fontFamily: "'Roboto', sans-serif", color: '#666666' }}>
                    © 2024 Powerbox Energy Systems LLC. All Rights Reserved.
                </p>
            </div>
        </div>
    );
}
